"use strict";

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DependencyDescriptor = void 0;

var DependencyDescriptor = function DependencyDescriptor(lifeTime, dependencies, instance) {
  _classCallCheck(this, DependencyDescriptor);

  this.lifeTime = lifeTime;
  this.dependencies = dependencies;
  this.instance = instance;
};

exports.DependencyDescriptor = DependencyDescriptor;